'use client';

import RegisterForm from '@/components/app/auth/register';
import { Badge } from '@/components/ui/badge';
import Link from 'next/link';
import Image from 'next/image';
import { Suspense } from 'react';

const services = [
  'Apartmani',
  'Vile',
  'Brodovi',
  'Izleti',
  'Restorani',
  'Aktivnosti',
];

export default function Home() {
  return (
    <Suspense>
      <div id='signup' className='min-h-screen bg-[#f7f7f7]'>
        <div className='mx-auto flex w-full max-w-6xl flex-col px-6 py-10 lg:py-14'>
          {/* HEADER */}

          <div className='mx-auto mb-12 w-full max-w-3xl text-center'>
            <Link href='/'>
              <Image
                src='/logo-b.png'
                alt='Meet Croatia'
                width={190}
                height={50}
                className='mx-auto'
              />
            </Link>

            <h1 className='mt-8 text-4xl font-semibold tracking-tight text-black'>
              Postanite partner
            </h1>

            <p className='mx-auto mt-4 max-w-2xl text-black/60'>
              Otvorite partner račun i počnite upravljati svojim objektima,
              uslugama i rezervacijama na Meet Croatia platformi.
            </p>

            {/* <div className='mt-8 flex flex-wrap justify-center gap-2'>
            {services.map((item) => (
              <Badge
                key={item}
                variant='outline'
                className='rounded-full border-black/10 bg-white px-4 py-1.5 text-black/70'>
                {item}
              </Badge>
            ))}
          </div> */}
          </div>

          {/* FORM */}

          <div className='mx-auto w-full max-w-4xl'>
            <RegisterForm />
          </div>
        </div>
      </div>
    </Suspense>
  );
}
